export default __webpack_public_path__ + "static/media/MindShareSS.4130c5a7.png";